import apiServices from "@/services/yungol-services";

const URL = "cultura";

// Processes
export const fetchProcesses = async () => {
  const response = await apiServices.get(`${URL}/processes`);

  if (response.status !== 200) {
    throw new Error("Error fetching processes");
  }

  return response.data;
};

export const fetchProcessById = async (id) => {
  const response = await apiServices.get(`${URL}/processes/${id}`);

  if (response.status !== 200) {
    throw new Error("Error fetching current process");
  }

  return response.data;
};

export const createProcess = async (data) => {
  const response = await apiServices.post(`${URL}/processes`, data);

  if (response.status !== 200) {
    throw new Error("Error creating process");
  }

  return response.data;
};

export const updateProcess = async (data) => {
  const response = await apiServices.put(`${URL}/processes`, data);

  if (response.status !== 200) {
    throw new Error("Error updating process");
  }

  return response.data;
};

export const deleteProcess = async (id) => {
  const response = await apiServices.delete(`${URL}/processes/${id}`);

  if (response.status !== 200) {
    throw new Error("Error deleting collaborator");
  }

  return response.data;
};

// Collaborators
export const fetchCollaborators = async (id) => {
  const response = await apiServices.get(`${URL}/collaborators/${id}`);

  if (response.status !== 200) {
    throw new Error("Error fetching collaborators");
  }

  return response.data;
};

export const createCollaborator = async (data) => {
  const response = await apiServices.post(`${URL}/collaborators`, data);

  if (response.status !== 200) {
    throw new Error("Error creating collaborator");
  }

  return response.data;
};

export const updateCollaborator = async (data) => {
  const response = await apiServices.put(`${URL}/collaborators`, data);

  if (response.status !== 200) {
    throw new Error("Error updating collaborator");
  }

  return response.data;
};

export const deleteCollaborator = async (id) => {
  const response = await apiServices.delete(`${URL}/collaborators/${id}`);

  if (response.status !== 200) {
    throw new Error("Error deleting collaborator");
  }

  return response.data;
};

export const uploadCollaborators = async (urlFile, idProcess) => {
  const response = await apiServices.post(`${URL}/collaborators/upload`, {
    url: urlFile,
    idProcess,
  });

  if (response.status !== 200) {
    throw new Error("Error uploading collaborators");
  }

  return response.data;
};

// Dependencies
export const fetchDependencies = async (id) => {
  const response = await apiServices.get(`${URL}/dependencies/${id}`);

  if (response.status !== 200) {
    throw new Error("Error fetching dependencies");
  }

  return response.data;
};

export const createDependences = async (data) => {
  const response = await apiServices.post(`${URL}/dependencies`, data);

  if (response.status !== 200) {
    throw new Error("Error creating dependence");
  }

  return response.data;
};

export const updateDependences = async (data) => {
  const response = await apiServices.put(`${URL}/dependencies`, data);

  if (response.status !== 200) {
    throw new Error("Error updating dependence");
  }

  return response.data;
};

export const deleteDependence = async (id) => {
  const response = await apiServices.delete(`${URL}/dependencies/${id}`);

  if (response.status !== 200) {
    throw new Error("Error deleting dependence");
  }

  return response.data;
};

// Survey
export const fetchSurvey = async (id) => {
  const response = await apiServices.get(`${URL}/survey/${id}`);

  if (response.status !== 200) {
    throw new Error("Error fetching survey");
  }

  return response.data;
};

export const fetchHistoryEmail = async (id) => {
  const response = await apiServices.get(`${URL}/email/history/${id}`);

  if (response.status !== 200) {
    throw new Error("Error fetching history email");
  }

  return response.data;
};

export const sendSurveyCollaborator = async (id) => {
  const response = await apiServices.get(`${URL}/survey/send/${id}`);

  if (response.status !== 200) {
    throw new Error("Error sending survey");
  }

  return response.data;
};

export const sendSurveys = async (id) => {
  const response = await apiServices.get(`${URL}/survey/send/all/${id}`);

  if (response.status !== 200) {
    throw new Error("Error sending surveys");
  }

  return response.data;
};

export const saveTermsAndConditions = async (data) => {
  const response = await apiServices.post(
    `${URL}/survey/terms-conditions`,
    data
  );

  if (response.status !== 200) {
    throw new Error("Error saving accept terms and conditions");
  }

  return response.data;
};

export const saveQuestions = async (data) => {
  const response = await apiServices.post(`${URL}/survey`, data);

  if (response.status !== 200) {
    throw new Error("Error saving surveys");
  }

  return response.data;
};

export const calculatedSurveysCollaborator = async (id) => {
  const response = await apiServices.put(`${URL}/surveys/calculated/${id}`);

  if (response.status !== 200) {
    throw new Error("Error calculated surveys");
  }

  return response.data;
};

// Results
export const getResultByProcess = async (id) => {
  const response = await apiServices.get(`${URL}/results/${id}`);

  if (response.status !== 200) {
    throw new Error("Error getting results board");
  }

  return response.data;
};

export const calculateBoardByProcess = async (id) => {
  const response = await apiServices.post(`${URL}/results`, { id });

  if (response.status !== 200) {
    throw new Error("Error calculated board");
  }

  return response.data;
};

export const getResultByDependency = async (id, dependencies) => {
  const response = await apiServices.post(`${URL}/results/dependency`, { id, dependencies });

  if (response.status !== 200) {
    throw new Error("Error getting filtered results");
  }

  return response.data;
};

// Shared (public) — used by the /cultura/share/:id/:filter dashboard
export const fetchProcessByIdShared = async (id) => {
  const response = await apiServices.get(`${URL}/process-shared/${id}`);

  if (response.status !== 200) {
    throw new Error("Error fetching shared process");
  }

  return response.data;
};

export const getSharedResults = async (id, dependencies = []) => {
  const response = await apiServices.post(`${URL}/results-shared`, {
    id,
    dependencies,
  });

  if (response.status !== 200) {
    throw new Error("Error getting shared results");
  }

  return response.data;
};



// WEBPACK FOOTER //
// ./src/components/cultura/api.js